module.exports = {
      id: "login-usage",
      viewBox: "0 0 14.742 20.333",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#login",
      toString: function () {
        return this.url;
      }
    }